// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.teacher-home-main {
  align-items: stretch;
  display: flex;
}

.teacher-home-wrapper {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  margin-bottom: 32px;
  min-height: 65vh;
  min-width: 0;
  width: 100%;
}
.teacher-home-wrapper .home-top-row {
  align-items: stretch;
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
}
.teacher-home-wrapper .section-container {
  border-radius: 10px;
  background-color: #676666;
  padding: 16px 24px;
  width: 100%;
}
.teacher-home-wrapper .section-container .sub-section-line {
  background-color: #EDEDED;
  color: #EDEDED;
  height: 1px;
  margin: 12px 0;
}
.teacher-home-wrapper .section-container .released-status-container {
  border-radius: 10px;
  background-color: #EDEDED;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  color: #0669B3;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
  width: fit-content;
}
.teacher-home-wrapper .section-container .released-status-container .grades-ready-title {
  font-weight: bold;
  margin-bottom: 8px;
}
.teacher-home-wrapper .section-container .released-status-container .released-grades-list {
  color: #444343;
}
.teacher-home-wrapper .section-container .released-status-container .released-grades-list span {
  color: #0669B3;
}
.teacher-home-wrapper .section-container .released-status-container .no-grades-released {
  color: #444343;
  line-height: 1.5;
}
.teacher-home-wrapper .section-container .updates-container {
  border-radius: 10px;
  background-color: #EDEDED;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  color: #0669B3;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 0;
  padding: 16px 20px;
}
.teacher-home-wrapper .section-container .updates-container .updates-title {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 8px;
}
.teacher-home-wrapper .section-container .updates-container .updates-text {
  font-weight: 450;
  line-height: 1.5;
}
.teacher-home-wrapper .home-top-row .section-container.top {
  display: flex;
  flex: 1 1 calc(50% - 8px);
  flex-direction: column;
  height: auto;
  margin-bottom: 0;
  min-width: 260px;
  width: auto;
}
.teacher-home-wrapper .home-top-row .section-container.top .updates-container {
  flex: 0 0 auto;
}
.teacher-home-wrapper .home-top-row .section-container.top:not(.home-resources) .updates-container {
  gap: 16px;
}
.teacher-home-wrapper .home-resources .updates-container {
  gap: 12px;
}
.teacher-home-wrapper .home-resources .home-resource-link {
  align-items: center;
  color: #0669B3;
  display: flex;
  font-size: 1rem;
  font-weight: 550;
  gap: 8px;
  text-decoration: none;
}
.teacher-home-wrapper .home-resources .home-resource-link:hover, .teacher-home-wrapper .home-resources .home-resource-link:focus {
  color: #1786DB;
  text-decoration: underline;
}
.teacher-home-wrapper .section-container.top {
  height: auto;
  margin-bottom: 16px;
}
.teacher-home-wrapper .section-container.bottom {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  height: auto;
  margin-bottom: 0;
  min-height: 0;
}
.teacher-home-wrapper .section-container.bottom .updates-container,
.teacher-home-wrapper .section-container.bottom .grade-status-panel {
  flex: 1 1 auto;
}
.teacher-home-wrapper .sub-section-title {
  align-items: flex-end;
  color: white;
  display: flex;
  font-size: 19.2px;
  font-weight: 700;
  justify-content: space-between;
}
@media only screen and (max-width: 900px) {
  .teacher-home-wrapper .home-top-row .section-container.top {
    flex: 1 1 100%;
    min-width: 0;
  }
}

.grade-status-panel__title {
  color: #0669B3;
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 12px;
}
.grade-status-panel__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.grade-chip {
  border-radius: 10px;
  min-width: 80px;
  padding: 12px 18px;
  text-align: center;
}
.grade-chip__grade {
  color: #444;
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 6px;
}
.grade-chip__status {
  font-size: 0.8rem;
  font-weight: 600;
}
.grade-chip__status i {
  margin-right: 4px;
}
.grade-chip--available {
  background: #e8f5e9;
  border: 1px solid #a5d6a7;
}
.grade-chip--available .grade-chip__status {
  color: #2e7d32;
}
.grade-chip--in-progress {
  background: #fff8e1;
  border: 1px solid #ffe082;
}
.grade-chip--in-progress .grade-chip__status {
  color: #e65100;
}
.grade-chip--not-started {
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
}
.grade-chip--not-started .grade-chip__status {
  color: #757575;
}

.right-side-wrapper {
  position: relative;
  background-color: #EDF0F1;
  border-radius: 10px;
  margin-bottom: 32px;
  min-height: 300px;
  padding: 24px;
  width: 100%;
}
.right-side-wrapper .helper-text {
  margin: 24px 0px;
}
.right-side-wrapper .right-page-title {
  color: #0669B3;
  font-weight: 700;
  margin-bottom: 24px;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/TeacherHome.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACI,oBAAA;EACA,aAAA;AAUJ;;AAPA;EACI,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;EAEA,gBAAA;EACA,YAAA;EACA,WAAA;AASJ;AAPI;EACI,oBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AASR;AANI;ECxBA,mBDyB0B;EACtB,yBAAA;EACA,kBAAA;EACA,WAAA;AAQR;AANQ;EACI,yBDlBJ;ECmBI,cDnBJ;ECoBI,WAAA;EACA,cAAA;AAQZ;AALQ;ECrCJ,mBDsC8B;EACtB,yBD1BJ;EC2BI,0CAAA;EACA,cDXC;ECYD,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;AAOZ;AALY;EACI,iBAAA;EACA,kBAAA;AAOhB;AAJY;EACI,cDzBP;AC+BT;AAJgB;EACI,cD3BP;ACiCb;AAFY;EACI,cDjCP;ECkCO,gBAAA;AAIhB;AAAQ;ECnEJ,mBDoE8B;EACtB,yBDxDJ;ECyDI,0CAAA;EACA,cDzCC;EC0CD,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AAEZ;AAAY;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;AAEhB;AACY;EACI,gBAAA;EACA,gBAAA;AAChB;AAII;EACI,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AAFR;AAIQ;EACI,cAAA;AAFZ;AAKQ;EACI,SAAA;AAHZ;AAQQ;EACI,SAAA;AANZ;AASQ;EACI,mBAAA;EACA,cDtFC;ECuFD,aAAA;EACA,eAAA;EACA,gBAAA;EACA,QAAA;EACA,qBAAA;AAPZ;AASY;EAEI,cD9FG;EC+FH,0BAAA;AARhB;AAaI;EACI,YAAA;EACA,mBAAA;AAXR;AAcI;EACI,aAAA;EACA,cAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;AAZR;AAcQ;;EAEI,cAAA;AAZZ;AAgBI;EACI,qBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BAAA;AAdR;AAiBI;EACI;IACI,cAAA;IACA,YAAA;EAfV;AACF;;AAoBI;EACI,cD3IK;EC4IL,iBAAA;EACA,gBAAA;EACA,mBAAA;AAjBR;AAoBI;EACI,aAAA;EACA,eAAA;EACA,SAAA;AAlBR;;AAsBA;EACI,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AAnBJ;AAqBI;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAnBR;AAsBI;EACI,iBAAA;EACA,gBAAA;AApBR;AAsBQ;EAAI,iBAAA;AAnBZ;AAsBI;EACI,mBAAA;EACA,yBAAA;AApBR;AAqBQ;EAAsB,cAAA;AAlB9B;AAqBI;EACI,mBAAA;EACA,yBAAA;AAnBR;AAoBQ;EAAsB,cAAA;AAjB9B;AAoBI;EACI,mBAAA;EACA,yBAAA;AAlBR;AAmBQ;EAAsB,cAAA;AAhB9B;;AAoBA;EACI,kBAAA;EACA,yBDxMI;ECyMJ,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,WAAA;AAjBJ;AAmBI;EACI,gBAAA;AAjBR;AAoBI;EACI,cD7MK;EC8ML,gBAAA;EACA,mBAAA;AAlBR","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.teacher-home-main {\n    align-items: stretch;\n    display: flex;\n}\n\n.teacher-home-wrapper {\n    display: flex;\n    flex: 1 1 auto;\n    flex-direction: column;\n    margin-bottom: 32px;\n    // Match expanded/collapsed sidebar height so bottoms can line up\n    min-height: 65vh;\n    min-width: 0;\n    width: 100%;\n\n    .home-top-row {\n        align-items: stretch;\n        display: flex;\n        flex: 0 0 auto;\n        flex-wrap: wrap;\n        gap: 16px;\n        margin-bottom: 16px;\n    }\n\n    .section-container {\n        @include borderRadius(10px);\n        background-color: #676666;\n        padding: 16px 24px;\n        width: 100%;\n\n        .sub-section-line {\n            background-color: $white;\n            color: $white;\n            height: 1px;\n            margin: 12px 0;\n        }\n\n        .released-status-container {\n            @include borderRadius(10px);\n            background-color: $white;\n            box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n            color: $pearl-blue;\n            display: flex;\n            flex-direction: column;\n            gap: 10px;\n            padding: 20px;\n            width: fit-content;\n\n            .grades-ready-title {\n                font-weight: bold;\n                margin-bottom: 8px;\n            }\n\n            .released-grades-list {\n                color: $grey4a;\n\n                span {\n                    color: $pearl-blue;\n                }\n            }\n\n            .no-grades-released {\n                color: $grey4a;\n                line-height: 1.5;\n            }\n        }\n\n        .updates-container {\n            @include borderRadius(10px);\n            background-color: $white;\n            box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n            color: $pearl-blue;\n            display: flex;\n            flex-direction: column;\n            gap: 10px;\n            margin-bottom: 0;\n            padding: 16px 20px;\n\n            .updates-title {\n                font-size: 16px;\n                font-weight: 700;\n                margin-bottom: 8px;\n            }\n\n            .updates-text {\n                font-weight: 450;\n                line-height: 1.5;\n            }\n        }\n    }\n\n    .home-top-row .section-container.top {\n        display: flex;\n        flex: 1 1 calc(50% - 8px);\n        flex-direction: column;\n        height: auto;\n        margin-bottom: 0;\n        min-width: 260px;\n        width: auto;\n\n        .updates-container {\n            flex: 0 0 auto;\n        }\n\n        &:not(.home-resources) .updates-container {\n            gap: 16px;\n        }\n    }\n\n    .home-resources {\n        .updates-container {\n            gap: 12px;\n        }\n\n        .home-resource-link {\n            align-items: center;\n            color: $pearl-blue;\n            display: flex;\n            font-size: 1rem;\n            font-weight: 550;\n            gap: 8px;\n            text-decoration: none;\n\n            &:hover,\n            &:focus {\n                color: $pearl-blue-hover;\n                text-decoration: underline;\n            }\n        }\n    }\n\n    .section-container.top {\n        height: auto;\n        margin-bottom: 16px;\n    }\n\n    .section-container.bottom {\n        display: flex;\n        flex: 1 1 auto;\n        flex-direction: column;\n        height: auto;\n        margin-bottom: 0;\n        min-height: 0;\n\n        .updates-container,\n        .grade-status-panel {\n            flex: 1 1 auto;\n        }\n    }\n\n    .sub-section-title {\n        align-items: flex-end;\n        color: white;\n        display: flex;\n        font-size: 19.2px;\n        font-weight: 700;\n        justify-content: space-between;\n    }\n\n    @media only screen and (max-width: 900px) {\n        .home-top-row .section-container.top {\n            flex: 1 1 100%;\n            min-width: 0;\n        }\n    }\n}\n\n.grade-status-panel {\n    &__title {\n        color: $pearl-blue;\n        font-size: 0.9rem;\n        font-weight: 600;\n        margin-bottom: 12px;\n    }\n\n    &__chips {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 10px;\n    }\n}\n\n.grade-chip {\n    border-radius: 10px;\n    min-width: 80px;\n    padding: 12px 18px;\n    text-align: center;\n\n    &__grade {\n        color: #444;\n        font-size: 1rem;\n        font-weight: 700;\n        margin-bottom: 6px;\n    }\n\n    &__status {\n        font-size: 0.8rem;\n        font-weight: 600;\n\n        i { margin-right: 4px; }\n    }\n\n    &--available {\n        background: #e8f5e9;\n        border: 1px solid #a5d6a7;\n        .grade-chip__status { color: #2e7d32; }\n    }\n\n    &--in-progress {\n        background: #fff8e1;\n        border: 1px solid #ffe082;\n        .grade-chip__status { color: #e65100; }\n    }\n\n    &--not-started {\n        background: #f5f5f5;\n        border: 1px solid #e0e0e0;\n        .grade-chip__status { color: #757575; }\n    }\n}\n\n.right-side-wrapper {\n    position: relative;\n    background-color: $grey0;\n    border-radius: 10px;\n    margin-bottom: 32px;\n    min-height: 300px;\n    padding: 24px;\n    width: 100%;\n\n    .helper-text {\n        margin: 24px 0px;\n    }\n\n    .right-page-title {\n        color: $pearl-blue;\n        font-weight: 700;\n        margin-bottom: 24px;\n    }\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
